import {Component, OnInit, signal} from '@angular/core';
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {CodaltComponent} from '../../codalt.component';
import {PpeService} from '../../services/ppe.service';
import {ActivatedRoute, Router, RouterLink} from '@angular/router';
import {PpeEquipment} from '../../ppe-equipment';
import {Utils} from '../../utils.class';
import {Routenames} from '../../route-names.enum';
import {ConfirmDialogService} from '../../services/confirm-dialog-service/confirm-dialog.service';
import {VvrIconComponent} from "../../vvr-icon/vvr-icon.component";
import {MatTooltip} from "@angular/material/tooltip";
import {MatError, MatFormField, MatInput} from "@angular/material/input";
import {MatButton} from "@angular/material/button";

@Component({
    selector: 'app-ppe-equipment-edit',
    templateUrl: './ppe-equipment-edit.component.html',
    styleUrls: ['./ppe-equipment-edit.component.scss'],
    imports: [
        VvrIconComponent,
        RouterLink,
        MatTooltip,
        ReactiveFormsModule,
        MatFormField,
        MatError,
        MatButton,
        MatInput
    ]
})
export class PpeEquipmentEditComponent extends CodaltComponent implements OnInit {

    fc: {
        name: FormControl
    };

    readonly form = signal<FormGroup>(null);

    readonly equipment = signal<PpeEquipment>(new PpeEquipment());

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private confirmDialog: ConfirmDialogService,
        private ppeService: PpeService
    ) {
        super();
    }

    ngOnInit(): void {
        this.subscriptions.add(this.route.params.subscribe(params => {
            this.ppeService.getEquipment(params['id']).subscribe(equipment => {
                this.equipment.set(equipment.data || new PpeEquipment());

                this.fc = {
                    name: new FormControl(this.equipment().name, Validators.required)
                };
                this.form.set(new FormGroup(this.fc));
            });
        }));
    }

    save() {
        Utils.triggerValidation(this.form());
        if (this.form().valid) {
            this.equipment().name = this.fc.name.value;
            this.ppeService.saveEquipment(this.equipment()).subscribe(() => {
                this.router.navigate([Routenames.ppeEquipment]);
            }, error => {
                this.confirmDialog.confirm(
                    'Fout bij het opslaan',
                    error.message,
                    'Sluiten'
                ).then(() => {

                }, () => {

                });
            });
        }
    }
}
